import React, { memo } from 'react';
import productParameterConfigs from './config';
import ProductParameterEditor from './ProductParameterEditor';
function ProductSustainabilityEditor({ create = false }) {
    return React.createElement(ProductParameterEditor, { config: productParameterConfigs.sustainability, create: create });
}
export default memo(ProductSustainabilityEditor);
